/**
 * Counts down to the next daily ItWord
 * (itword/templates/itword/components/_next_itword_countdown.html). The finished
 * modal is swapped in by htmx, so each tick looks the countdowns up afresh
 * rather than binding to them once on load.
 *
 * The target comes from the server, so the local clock's timezone doesn't
 * matter. Once it passes, the countdown is swapped for a link to the new game.
 */
import { formatHms } from './time.js'

const tick = () => {
    document.querySelectorAll('[data-countdown-to]').forEach((time) => {
        const remaining = Date.parse(time.dataset.countdownTo) - Date.now()
        if (remaining > 0) {
            time.textContent = formatHms(Math.ceil(remaining / 1000))
            return
        }

        const countdown = time.closest('[data-countdown]')
        countdown.nextElementSibling?.classList.remove('hidden')
        countdown.remove()
    })
}

tick()
setInterval(tick, 1000)
